import { render } from "./Confirmation.vue?vue&type=template&id=1c83fc0e&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"

import "./Confirmation.vue?vue&type=style&index=0&id=1c83fc0e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c83fc0e"]])

export default __exports__